import {
  IBenefitDefaultSettings,
  IBenefitGroupDetails,
  ICreateBenefitGroupForm
} from '@epi-models/pages/BenefitGroups';
import { toDot } from './commaHelper';
import { BenefitType } from '@epi-constants/benefitTypes';
import { LunchFundsLoadingValues } from '@epi-models/pages/Home';

export const formatValuesToDTO = (values: ICreateBenefitGroupForm) => {
  const formattedSettings = {};

  for (const [benefitType, benefitSettings] of Object.entries(
    values.benefitSettings
  )) {
    if (benefitSettings) {
      formattedSettings[benefitType] = {
        ...benefitSettings,
        maxAmountPerPeriod: benefitSettings?.maxAmountPerPeriod
          ? +toDot(benefitSettings?.maxAmountPerPeriod)
          : undefined
      };
    }
  }

  return {
    groupName: values.groupName,
    benefitSettings: formattedSettings
  } as ICreateBenefitGroupForm;
};

export const mapBenefitsToSettings = (
  defaultSettings?: IBenefitDefaultSettings,
  groupDetails?: IBenefitGroupDetails
) => {
  if (!defaultSettings) {
    return undefined;
  }
  const settings = {};

  for (const {
    maxAmount,
    taxFreeAmount,
    benefitType
  } of defaultSettings.contractedBenefits) {
    const existingSetting = groupDetails?.benefitSettings?.find(
      s => s.benefitType === benefitType
    );
    if (groupDetails && !existingSetting) {
      continue;
    }
    const defaultMaxAmount = taxFreeAmount ?? maxAmount;
    if (benefitType === BenefitType.Lunch) {
      settings[benefitType] = {
        maxAmountPerPeriod:
          existingSetting?.maxAmountPerPeriod ??
          defaultSettings.lunchGlobalSettings?.maxAmountPerPeriod ??
          defaultMaxAmount,
        isMaximumSpendingLimit:
          defaultSettings.lunchGlobalSettings?.isMaximumSpendingLimit ?? true,
        fundsLoadingType: defaultSettings.lunchGlobalSettings
          ?.fundsLoadingType as LunchFundsLoadingValues,
        recurringTopupRequestEnabled:
          existingSetting?.recurringTopupRequestEnabled ?? false
      };
    } else {
      settings[benefitType] = {
        maxAmountPerPeriod:
          existingSetting?.maxAmountPerPeriod ?? defaultMaxAmount
      };
    }
  }
  return settings;
};
